import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo } from "react";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

const AfinaDateTabs = ({ selectedDate, onDateChange }) => {
  const today = useMemo(() => dayjs().tz(TZ), []);
  const todayString = today.format("YYYY-MM-DD");

  const dateOptions = useMemo(() => {
    const options = [];

    options.push({
      value: "live",
      label: "Live",
      type: "live",
    });

    options.push({
      value: todayString,
      label: "Hôm nay",
      type: "today",
    });

    const tomorrow = today.clone().add(1, "day");
    options.push({
      value: tomorrow.format("YYYY-MM-DD"),
      label: "Ngày mai",
      type: "tomorrow",
    });

    for (let i = 2; i <= 7; i++) {
      const d = today.clone().add(i, "day");
      options.push({
        value: d.format("YYYY-MM-DD"),
        label: d.format("DD/MM"),
        type: "future",
      });
    }

    return options;
  }, [today, todayString]);

  const getButtonClass = (isActive) => {
    const base =
      "afina-date-tab shrink-0 inline-flex items-center justify-center whitespace-nowrap rounded-lg px-1 py-1 text-sm font-semibold transition-all active:scale-[0.98]";
    return isActive ? `${base} afina-date-tab--active` : base;
  };

  const getMinWidth = (type) => {
    if (type === "live") return "min-w-[110px]";
    if (type === "today" || type === "tomorrow") return "min-w-[90px]";
    return "min-w-[70px]";
  };

  return (
    <div className="w-full">
      <div className="flex overflow-x-auto gap-1.5 max-md:scrollbar-hide">
        {dateOptions.map((opt) => {
          const isSelected = selectedDate === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onDateChange(opt.value)}
              className={`${getButtonClass(isSelected)} ${getMinWidth(opt.type)}`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AfinaDateTabs;
